import { connectedComponent } from 'utils/redux/providerWrapper';
import { HeaderIconsWrapper } from './header_icons';

export const ConnectedHeaderIconsWrapper =
  connectedComponent(HeaderIconsWrapper);

export default HeaderIconsWrapper;
